import * as React from 'react';
import { SelectSingle } from 'ui/select-single/select-single';
import { ComplexValue } from 'ui/common/types';
import { OptionsType } from 'ui/common/select/types';
import styles from './sort-by-select.scss';

export interface SortBySelectProps {
  translation: any;
  valueItem: ComplexValue<number>;
  options: ComplexValue<number>[];
  onChange: (valueItem: ComplexValue<number>) => void;
}

export class SortBySelect extends React.Component<SortBySelectProps> {

  private onLoadOptions = () => {
    return;
  };

  public render() {

    const label = {
      visible: true,
      isRequired: true
    };

    return <div className={styles.sortBySelect}>
      <SelectSingle
        componentId={'1'}
        className={'select-single'}
        label={label}
        valueItem={this.props.valueItem}
        options={this.props.options}
        optionsDisplaySetting={{ type: OptionsType.flat }}
        showIcons={true}
        onChange={this.props.onChange}
        onLoadOptions={this.onLoadOptions}
        readOnly={false}
        disabled={true}
        placeholder={''}
        textOptionsDone={this.props.translation && this.props.translation.done}
        textPageOf={this.props.translation && this.props.translation.page_of}
      />
    </div>;
  }
}
